<template>
  <Picker
    :data="emojiIndex"
    :background-image-fn="
      () => {
        return '/assets/emoji/32.png';
      }
    "
    :show-preview="true"
    :show-skin-tones="true"
    :show-search="false"
    :native="true"
    emoji="memo"
    :title="$t('emoji.title')"
    :i18n="{
      search: $t('emoji.search'),
      notfound: $t('emoji.not_found'),
      categories: {
        search: $t('emoji.category.search'),
        recent: $t('emoji.category.recent'),
        people: $t('emoji.category.people'),
        nature: $t('emoji.category.nature'),
        foods: $t('emoji.category.foods'),
        activity: $t('emoji.category.activity'),
        places: $t('emoji.category.places'),
        objects: $t('emoji.category.objects'),
        symbols: $t('emoji.category.symbols'),
        flags: $t('emoji.category.flags'),
        custom: $t('emoji.category.custom'),
      },
      skins: {
        choose: $t('emoji.skin.choose'),
        1: $t('emoji.skin.1'),
        2: $t('emoji.skin.2'),
        3: $t('emoji.skin.3'),
        4: $t('emoji.skin.4'),
        5: $t('emoji.skin.5'),
        6: $t('emoji.skin.6'),
      },
    }"
    @select="emojiSelected"
  />
</template>
<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
// @ts-expect-error this library is not typed :(
import { Picker } from 'emoji-mart-vue-fast/src';
import { emojiIndex } from './emojiIndex';
import type { TEmoji } from './t-emoji';
const emit = defineEmits<{ emojiSelected: [TEmoji] }>();
function emojiSelected(
  // eslint-disable-next-line @typescript-eslint/naming-convention
  emoji: { colons: string; short_name: string },
) {
  emit('emojiSelected', {
    colons: emoji.colons,
    shortName: emoji.short_name,
  });
}
</script>
